import React from 'react'
import { NumberText } from '../../../Global'

export const TableDataCellRoas = ({ dataValue }: { dataValue?: number }) => {
  return <NumberText value={Number(dataValue)} maximumFractionDigits={2} />
}
